import { CaretLeft, CaretRight } from "phosphor-react"
import React from "react"

export default ({ className = "", onLeftClick, color, showBackground = true, onRightClick, leftEnabled = true, rightEnabled = true, leftVisible = true, rightVisible = true, size }) => (<>
    {leftVisible && <div className={`slider-arrow slider-arrow--left ${className} ${!showBackground ? "slider-arrow--hide-background": ""}`} onClick={leftEnabled && onLeftClick}>
        <CaretLeft size={size} color={color} />
    </div>}
    {rightVisible && <div className={`slider-arrow slider-arrow--right ${className} ${!showBackground ? "slider-arrow--hide-background" : ""}`} onClick={rightEnabled && onRightClick}>
        <CaretRight size={size} color={color} />
    </div>}
</>)